/* eslint-disable @typescript-eslint/no-explicit-any */
import { camelCase } from "change-case";
import { set, get } from "lodash";

export const isDev: boolean = process.env.NODE_ENV === "development";

export const flatPick = (object: any, paths: string[]) => {
  const newObject = {};
  paths.forEach((path) => set(newObject, path, get(object, path)));
  return newObject;
};

export const convertNumberToString = (value: any) => {
  if (typeof value === "number") {
    return value.toString();
  }
  return value;
};

export const convertStringToDate = (value: string) => {
  if (typeof value === "string" && value.match(/\d{4}-[01]\d-[0-3]/)) {
    return new Date(value);
  }
  return value;
};

export const deflateObject = (object: any) => {
  const result = {} as any;
  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (const key in object) {
    const newKey = key.endsWith("Ids") ? key.replace("Ids", "s") : key;
    // eslint-disable-next-line no-underscore-dangle
    if (object[key]?.__typename && object[key]?.id) {
      result[newKey] = convertNumberToString(object[key].id);
    } else {
      result[newKey] = object[key];
    }
    if (key === "id") {
      result[key] = convertNumberToString(object[key]);
    }
    if (Array.isArray(object[key])) {
      const notDeflate = object[key][0]?.__notDeflate;
      result[newKey] = notDeflate
        ? object[key]
        : object[key].map((item: any) =>
            item.id ? String(item.id) : convertNumberToString(item)
          );
    }
    result[newKey] = convertStringToDate(result[newKey]);
  }
  return result;
};

export const removeEmptyValues = (obj: any): any => {
  if (obj instanceof Array) {
    return obj
      .filter((v) => v !== null && v !== undefined)
      .map((v) => (v instanceof Object ? removeEmptyValues(v) : v));
  }

  return Object.fromEntries(
    Object.entries(obj)
      .filter(([, v]) => v !== null && v !== undefined)
      .map(([k, v]) => [
        k,
        v instanceof Object && !(v instanceof Date) ? removeEmptyValues(v) : v,
      ])
  );
};

export const mergeHelper = (store: any, data: any): any => {
  const merge = (data: any): any => {
    try {
      if (!data || typeof data !== "object") return data;
      if (Array.isArray(data)) return data.map(merge);

      // eslint-disable-next-line no-underscore-dangle
      if (typeof data === "object" && !data.__typename) {
        return merge(Object.values(data));
      }

      const snapshot: any = {};
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const key in data) {
        snapshot[key] = merge(data[key]);
      }
      // eslint-disable-next-line no-underscore-dangle
      const currentStore = store[data.__typename];
      if (!currentStore) {
        console.log("store not exist", data.__typename);
        // eslint-disable-next-line no-underscore-dangle
        return null;
      }
      const deflatedObject = deflateObject(data);
      if (!store?.[data.__typename]?.addItem)
        console.log("!!!!", data.__typename);
      store[data.__typename].addItem(removeEmptyValues(deflatedObject));
    } catch (error) {
      console.error(error);
    }
  };

  return merge(data);
};

export const addMonthsToDate = (date: Date, months: number): Date => {
  const result = new Date(date);
  result.setMonth(result.getMonth() + months);
  return result;
};

export const setMidnight = (date: Date) => {
  const midnight = new Date(date);
  midnight.setHours(0, 0, 0, 0);
  return midnight;
};

export const transformObjectKeys = (obj: any) => {
  if (obj === null || obj === undefined) {
    return obj;
  }

  let newObj = obj;

  if (typeof newObj === "object") {
    if (obj instanceof Array) {
      newObj = obj.map(transformObjectKeys);
    } else {
      newObj = {};

      Object.keys(obj).forEach((key) => {
        if (key === "id") {
          newObj[camelCase(key)] = transformObjectKeys(String(obj[key]));
        } else {
          newObj[camelCase(key)] = transformObjectKeys(obj[key]);
        }
      });
    }
  }

  return newObj;
};
